import { render, staticRenderFns } from "./StudentInfoOnTicket.vue?vue&type=template&id=bec745aa&"
import script from "./StudentInfoOnTicket.vue?vue&type=script&lang=js&"
export * from "./StudentInfoOnTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports